import { FC } from "react";
import { Form, Input, Select } from "antd";
import { Country, State } from "../../types/country";

interface StateSelectProps {
  name?: string | (string | number)[]
  selectedCountry: any
  countryData: Country[]
  disabled?: boolean
}

const StateSelect: FC<StateSelectProps> = (props) => {
  const states = props.countryData.find(
    (country: Country) => country.countryCode === props.selectedCountry
  )?.states;

  if (states && states.length > 0) {
    return (
      <Form.Item
        label="State / Province"
        name={props.name}
        rules={[{ required: true, message: "Please enter state or province" }]}
      >
        <Select placeholder="State / Province" style={{ width: 200 }} showSearch optionFilterProp="children" disabled={props.disabled}>
          {states.map((item: State) => (
            <Select.Option key={item.stateCode} value={item.stateName}>
              {item.stateName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    )
  } else {
    return (
      <Form.Item
        label="State / Province"
        name={props.name}
      >
        <Input
          type="text"
        />
      </Form.Item>
    )
  }
}

export default StateSelect;